const axios = require('axios');

export default {
    namespaced: true,
    state: {
        definitionId: '',
        pageIndex: 0,
        itemsPerPage: 50,
        items: [],
        numTotalItems: 0,
        terms: '',
        sortBy: [{ name: 'lname', direction: 'asc' }, { name: 'fname', direction: 'asc' }],
    },
    getters: {
        getDefinitionId(state) {
            return state.definitionId;
        },
        getDefinition(state, getters, rootState, rootGetters) {
            return rootGetters['dataElements/getDefinitionById'](state.definitionId);
        },
        getPageIndex(state) {
            return state.pageIndex;
        },
        getItemsPerPage(state) {
            return state.itemsPerPage;
        },
        getNumTotalItems(state) {
            return state.numTotalItems;
        },
        getItems(state) {
            return state.items;
        },
        getTerms(state) {
            return state.terms;
        },
        getSortBy(state) {
            return state.sortBy;
        },
        getNumPages(state) {
            return Math.ceil(state.numTotalItems / state.itemsPerPage);
        }
    },
    mutations: {
        setDefinitionId(state, definitionId) {
            state.definitionId = definitionId;
        },
        setPageIndex(state, pageIndex) {
            state.pageIndex = parseInt(pageIndex);
        },
        setItemsPerPage(state, itemsPerPage) {
            let maxPageindex = Math.ceil(state.numTotalItems / itemsPerPage) - 1;

            if (state.pageIndex > maxPageindex) {
                state.pageIndex = maxPageindex;
            }

            state.itemsPerPage = parseInt(itemsPerPage);
        },
        setItems(state, items) {
            state.items = items;
        },
        setNumTotalItems(state, num) {
            state.numTotalItems = parseInt(num);
        },
        setSortBy(state, sortBy = null) {
            state.sortBy = sortBy;
        },
        setTerms(state, terms) {
            state.terms = terms;
        },
        updateLocalItem(state, { id, data }) {
            let oldItem = state.items.find(item => item.id === id);

            for (let key in data) {
                oldItem[key] = data[key];
            }
        }
    },
    actions: {
        async load({ commit, getters, dispatch }, reqId = '') {
            try {
                let res = await dispatch('dataElements/search', {
                    definitionId: getters.getDefinitionId,
                    offset: getters.getPageIndex * getters.getItemsPerPage,
                    limit: getters.getItemsPerPage,
                    terms: getters.getTerms,
                    sortBy: getters.getSortBy,
                    inputId: 'data-elem-list'
                }, { root: true });

                commit('setItems', res.items);
                commit('setNumTotalItems', res.count);
            } catch (e) {
                if (!axios.isCancel(e)) throw (e);
            }

            return reqId;
        },
        async addEditDialog({ dispatch }, { data, definition }) {
            await dispatch('dialog/set', {
                componentName: 'add-edit-contact',
                dialogProps: {
                    showHeader: false,
                    showFooter: false,
                    showX: true,
                },
                bodyComponentProps: {
                    data,
                    definition
                }
            }, { root: true });
        }
    }
}
